module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "btnew"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _vm._v("T"), _c('span', {
    staticClass: "smallf"
  }, [_vm._v("HIRTEEN MONTHS")])]), _vm._v(" "), _c('h1', {
    staticClass: "btnew"
  }, [_c('span', {
    staticClass: "smallf"
  }, [_vm._v("IN")])]), _vm._v(" "), _c('h1', {
    staticClass: "btnew1"
  }, [_vm._v("D"), _c('span', {
    staticClass: "smallf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("IXIE,")])])]), _vm._v(" "), _c('h1', {
    staticClass: "btnew"
  }, [_c('span', {
    staticClass: "smallf"
  }, [_vm._v("OR, THE")])]), _vm._v(" "), _c('h1', {
    staticClass: "btnew"
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallf"
  }, [_vm._v("DVENTURES OF")])]), _vm._v(" "), _c('h1', {
    staticClass: "btnew"
  }, [_c('span', {
    staticClass: "smallf"
  }, [_vm._v("A FEDERAL PRISONER")])]), _vm._v(" "), _c('h1', {
    staticClass: "btnew"
  }, [_c('span', {
    staticClass: "smallf"
  }, [_vm._v("IN")])]), _vm._v(" "), _c('h1', {
    staticClass: "btnew1"
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("EXAS")])])]), _vm._v(" "), _c('p', {
    staticClass: "bkaut"
  }, [_vm._v("William Francis Oscar Federhen")]), _vm._v(" "), _c('p', {
    staticClass: "bkaut1"
  }, [_vm._v("Jeaninne Surette Honstein and")]), _vm._v(" "), _c('p', {
    staticClass: "bkaut2"
  }, [_vm._v("Steven A. Knowlton, editors")]), _vm._v(" "), _c('div', {
    staticClass: "img_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/logo.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "logo"
  }, [_vm._v("Savas Beatie")]), _vm._v(" "), _c('p', {
    staticClass: "logo"
  }, [_vm._v("California")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ced84028","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/01_Title.vue
// module id = 57
// module chunks = 0